import React, { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import styles from "./styles.module.scss";

const BLOB =
  "https://bloblandingpageprd.blob.core.windows.net/toyota/geral/home-servicos-conectado";

const cardsData = [
  {
    title: "SAÚDE DO VEÍCULO",
    description:
      "Receba diagnósticos completos, detecte falhas e saiba quando agir, auxiliando a manter a segurança do seu veículo.",
    imageUrl: `${BLOB}/cards/card1.jpg`,
  },
  {
    title: "SEGURANÇA",
    description:
      "Monitore o carro em tempo real, crie cercas geográficas, conte com rastreamento e assistência 24 horas etc.*",
    obs: "*Funcionalidades disponíveis apenas no plano Segurança Conectada",
    imageUrl: `${BLOB}/cards/card2.png`,
  },
  {
    title: "CONEXÃO WI-FI",
    description:
      "Conecte até 8 dispositivos com Wi-Fi a bordo, garantindo internet segura e planos acessíveis.",
    imageUrl: `${BLOB}/cards/card3.png`,
  },
  {
    title: "STATUS DO VEÍCULO",
    description:
      "Acompanhe o nível de combustível, quilometragem e status do motor com atualizações em tempo real.",
    imageUrl: `${BLOB}/cards/card4.png`,
  },
  {
    title: "LOCALIZAÇÃO EM TEMPO REAL",
    description:
      "Saiba onde seu veículo está estacionado ou em movimento, garantindo maior segurança e facilidade.",
    imageUrl: `${BLOB}/cards/card5.jpg`,
  },
  {
    title: "ÚLTIMAS VIAGENS",
    description:
      "Veja dados como velocidade média, distâncias percorridas e pontos de partida e destino, tudo em um só lugar.",
    imageUrl: `${BLOB}/cards/card6.jpg`,
  },
  {
    title: "MONITORAMENTO APRIMORADO",
    description:
      "Se o sistema detectar uma desaceleração brusca, o Call Center entra em ação, contatando o cliente e, se necessário, as autoridades.*",
    obs: "*Funcionalidades disponíveis apenas no plano Segurança Conectada",
    imageUrl: `${BLOB}/cards/card7.jpg`,
  },
  {
    title: "NOTIFICAÇÃO DE ALARME",
    description:
      "Sempre que o alarme for acionado, seja por tentativa de invasão ou movimento suspeito, você será avisado no aplicativo, podendo acionar o rastreamento.",
    obs: "*Funcionalidades disponíveis apenas no plano Segurança Conectada",
    imageUrl: `${BLOB}/cards/card8.jpg`,
  },
  {
    title: "IMOBILIZAÇÃO DE VEÍCULO",
    description:
      "Em casos de furto, você pode solicitar que o veículo seja bloqueado impedindo-o de ser ligado novamente até que a imobilização seja desativada.",
    obs: "*Funcionalidades disponíveis apenas no plano Segurança Conectada",
    imageUrl: `${BLOB}/cards/card9.png`,
  },
  {
    title: "RASTREIO DE VEÍCULO ROUBADO",
    description:
      "Em caso de roubo, a Toyota oferece rastreamento eficiente para recuperar seu veículo.",
    obs: "*Funcionalidades disponíveis apenas no plano Segurança Conectada",
    imageUrl: `${BLOB}/cards/card10.jpg`,
  },
  {
    title: "CERCA GEOGRÁFICA",
    description:
      "Se o carro sair ou entrar nessa zona, você recebe uma notificação no app, garantindo mais segurança e controle.*",
    obs: "*Funcionalidades disponíveis apenas no plano Segurança Conectada",
    imageUrl: `${BLOB}/cards/card11.jpg`,
  },
  {
    title: "ALERTA DE VELOCIDADE",
    description:
      "Com o Alerta de Velocidade, você define um limite máximo para a velocidade do seu carro e é notificado sempre que ele for ultrapassado.",
    obs: "*Funcionalidades disponíveis apenas no plano Segurança Conectada",
    imageUrl: `${BLOB}/cards/card12.png`,
  },
];

const carData = [
  {
    imageSrc: `${BLOB}/ModelosLaterais.png`,
    altText: "Modelo Lateral Corolla",
    title: "COROLLA",
    description:
      "Modelo: 2025\nVersões: GR-Sport / Altis Premium / Altis Hybrid Premium",
    buttonText: "SAIBA +",
    url: "/corolla",
  },
  {
    imageSrc: `${BLOB}/ModelosLaterais-1.png`,
    altText: "Modelo Lateral Hilux",
    title: "HILUX",
    description: "Modelos 2025:\nSRV / SRX / SRX Plus",
    buttonText: "SAIBA +",
    url: "/hilux",
  },
  {
    imageSrc: `${BLOB}/ModelosLaterais-2.png`,
    altText: "Modelo Lateral Corolla Cross",
    title: "COROLLA CROSS",
    description: "Modelo: 2026\nVersões: GR-Sport / XRX / XRX Hybrid",
    buttonText: "SAIBA +",
    url: "/corolla-cross",
  },
  {
    imageSrc: `${BLOB}/ModelosLaterais-3.png`,
    altText: "Modelo Lateral SW4",
    title: "SW4",
    description: "Modelos 2025:\nPlatinum / Diamond",
    buttonText: "SAIBA +",
    url: "/sw4",
  },
  {
    imageSrc: `${BLOB}/ModelosLaterais-4.png`,
    altText: "Modelo Lateral Yaris Cross",
    title: "YARIS CROSS",
    description: "Modelo: 2026\nXRX / XRX Hybrid",
    buttonText: "SAIBA +",
    url: "/yaris-cross",
  },
  {
    imageSrc: `${BLOB}/ModelosLaterais-5.png`,
    altText: "Modelo Lateral Hiace",
    title: "HIACE",
    description: "Modelos 2025: Furgão\nModelos 2026: Minibus/Furgão",
    buttonText: "SAIBA +",
    url: "/hiace",
  },
];

const planData = [
  {
    title: "SEMPRE CONECTADO",
    titleLine1: "SEMPRE",
    titleLine2: "CONECTADO",
    status: "GRATUITO",
    duration: "por 5 anos",
    features: [
      "Diagnóstico de veículo",
      "Localização em tempo real",
      "Pontuação de combustível",
      "Status do veículo",
      "Últimas viagens",
    ],
    isFree: true,
    headerSvg: `${BLOB}/Card-price1.svg`,
    buttonText: "SAIBA +",
    url: "https://www.toyota.com.br/meu-toyota/conectado",
  },
  {
    title: "SEGURANÇA CONECTADA",
    titleLine1: "SEGURANCA",
    titleLine2: "CONECTADA",
    features: [
      "Alerta de velocidade",
      "Assistência 24h",
      "Cerca geográfica",
      "Imobilização do veículo",
      "Lembretes de revisão",
      "Monitoramento aprimorado",
      "Notificação de alarme",
      "Rastreio de veículo roubado",
    ],
    isFree: false,
    headerSvg: `${BLOB}/Card-price2.svg`,
    buttonText: "SAIBA +",
    url: "https://www.toyota.com.br/meu-toyota/conectado",
  },
];

const appFeaturesData = [
  {
    title: "Adicione seu veículo",
    description:
      "Com o chassi em mãos, adicione seu veículo com facilidade e tenha acesso a diversas funcionalidades que vão deixar o seu aplicativo mais personalizado! Customize sua visualização, é possível escolher o fundo de imagem para cada veículo e dar um nome que o ajude na identificação. Além disso, mantenha o índice de quilometragem atualizado e agende seus serviços com a nossa rede de concessionárias.",
    imageUrl: `${BLOB}/cards/feature1.png`,
    imagePosition: "left",
  },
  {
    title: "Concessionárias mais próximas",
    description:
      "Para um atendimento mais ágil e de qualidade, elija suas concessionárias favoritas e tenha fácil acesso ao seu contato! Caso já tenha alguma concessionária de preferência, você pode torná-la como uma favorita dentro do aplicativo, e na tela inicial e para outras funcionalidades que for realizar, ela irá aparecer como uma das primeiras opções. E o melhor, até 5 podem ser escolhidas!",
    imageUrl: `${BLOB}/cards/feature2.png`,
    imagePosition: "right",
  },
  {
    title: "Agende serviços",
    description:
      "Tenha facilidade em seu dia a dia realizando o agendamento dos serviços para o seu veículo através do aplicativo! É possível localizar uma concessionária mais próxima, verificar as especialidades disponíveis e agendar o seu serviço através do WhatsApp, garantindo assim a manutenção em dia do seu Toyota.",
    imageUrl: `${BLOB}/cards/feature3.png`,
    imagePosition: "left",
  },
  {
    title: "Simule financiamentos",
    description:
      "O Banco Toyota tem condições exclusivas para você que deseja financiar um veículo. Conta com taxas competitivas, flexibilidade para pagar e toda a segurança da marca Toyota! Acesse o Banco Toyota no aplicativo e faça uma simulação com entrada, parcela e prazo mais adequados para você e descubra as vantagens de ter um Toyota. Além disso, para os já clientes do Banco Toyota, acesse a área logada e tenha acesso a: emissão de boletos de 2° via, quitação e antecipação, e atualize também o seu cadastro.",
    imageUrl: `${BLOB}/cards/feature4.png`,
    imagePosition: "right",
  },
];

const ServicosConectadosPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"servicos" | "app">("servicos");
  const [isMobile, setIsMobile] = useState(false);
  const [currentCarIndex, setCurrentCarIndex] = useState(0);

  const handleAppDownload = () => {
    window.open("https://onelink.to/vnyzmb", "_blank");
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const nextCar = () => {
    setCurrentCarIndex((prev) => (prev + 1) % carData.length);
  };

  const prevCar = () => {
    setCurrentCarIndex((prev) => (prev - 1 + carData.length) % carData.length);
  };

  const bannerImage =
    activeTab === "servicos"
      ? isMobile
        ? `${BLOB}/banner_mbl_2.jpg`
        : `${BLOB}/banner_servicos_conectados.jpg`
      : isMobile
        ? `${BLOB}/banner_mbl.png`
        : `${BLOB}/banner_toyota_app.jpg`;

  const scrollToPlans = () => {
    document.getElementById("plans-section")?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className={styles.container}>
        <Image
          src={bannerImage}
          alt={activeTab === "servicos" ? "Serviços Conectados" : "Toyota App"}
          width={1920}
          height={720}
          sizes="100vw"
          className={styles.bannerImage}
          priority
        />
        {activeTab === "servicos" && (
          <div className={styles.bannerContent}>
            <h1 className={styles.bannerTitle}>Toyota Conectado</h1>
            <h2 className={styles.bannerSubtitle}>
              Sua experiência de direção elevada a outro nível
            </h2>
            <p className={styles.bannerDescription}>
              Monitore, controle e cuide do seu Toyota onde estiver, com
              segurança, praticidade e tecnologia de ponta.
            </p>
            <div className={styles.bannerButtons}>
              <button
                className={`${styles.bannerButton} ${styles.primary}`}
                onClick={handleAppDownload}
              >
                ATIVE AGORA
              </button>
              <button
                className={`${styles.bannerButton} ${styles.secondary}`}
                onClick={scrollToPlans}
              >
                CONHEÇA OS PLANOS
              </button>
            </div>
          </div>
        )}
        {activeTab === "app" && (
          <div className={styles.bannerContent}>
            <h1 className={styles.bannerTitle}>Toyota App</h1>
            <h2 className={styles.bannerSubtitleToyotaApp}>
              Tudo que a Toyota oferece em um só lugar
            </h2>
            <p className={styles.bannerDescription}>
              Baixe agora na Play Store ou App Store.
            </p>
            <div className={styles.bannerButtons}>
              <button
                className={`${styles.bannerButton} ${styles.primary}`}
                onClick={handleAppDownload}
              >
                ATIVE AGORA
              </button>
            </div>
          </div>
        )}
      </div>

      <div className={styles.tabContainer}>
        <button
          onClick={() => setActiveTab("servicos")}
          className={`${styles.tabButton} ${
            activeTab === "servicos" ? styles.active : ""
          }`}
        >
          Serviços Conectados
        </button>
        <button
          onClick={() => setActiveTab("app")}
          className={`${styles.tabButton} ${
            activeTab === "app" ? styles.active : ""
          }`}
        >
          Toyota App
        </button>
      </div>

      <div className={styles.contentContainer}>
        {activeTab === "servicos" && (
          <div>
            <h2>
              Tudo o que você pode fazer com <br />
              Toyota Conectado
            </h2>
            <div className={styles.cardsGrid}>
              {cardsData.map((card, index) => (
                <div key={card.title} className={styles.card}>
                  <div className={styles.cardIcon}>
                    <Image
                      src={card.imageUrl}
                      alt={card.title}
                      width={1200}
                      height={600}
                      className={styles.cardImage}
                      sizes="(max-width: 768px) 100vw, 33vw"
                      quality={100}
                      priority={index < 3}
                    />
                  </div>
                  <div className={styles.cardContent}>
                    <h3 className={styles.cardTitle}>{card.title}</h3>
                    <p className={styles.cardDescription}>{card.description}</p>
                    {card.obs && <p className={styles.cardObs}>{card.obs}</p>}
                  </div>
                </div>
              ))}
            </div>

            <div className={styles.centeredSectionWithBg}>
              <h2>Veículos Conectados</h2>

              <div className={styles.modelosLateraisContainer}>
                {carData.map((car) => (
                  <div key={car.title} className={styles.modeloLateralItem}>
                    <Image
                      src={car.imageSrc}
                      alt={car.altText}
                      width={300}
                      height={200}
                      className={styles.modeloLateralImage}
                    />
                    <div className={styles.modeloLateralInfo}>
                      <h3>{car.title}</h3>
                      <p>{car.description}</p>
                      <Link href={car.url}>
                        <button className={styles.saibaMaisButton}>
                          {car.buttonText}
                        </button>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>

              <div className={styles.carouselContainer}>
                <button
                  className={`${styles.carouselArrow} ${styles.left}`}
                  onClick={prevCar}
                  aria-label="Veículo anterior"
                >
                  <svg viewBox="0 0 24 24">
                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                  </svg>
                </button>

                {carData.map((car, index) => (
                  <div
                    key={car.title}
                    className={`${styles.carouselItem} ${
                      index === currentCarIndex ? styles.active : ""
                    }`}
                  >
                    <div className={styles.modeloLateralItem}>
                      <Image
                        src={car.imageSrc}
                        alt={car.altText}
                        width={300}
                        height={200}
                        className={styles.modeloLateralImage}
                      />
                      <div className={styles.modeloLateralInfo}>
                        <h3>{car.title}</h3>
                        <p>{car.description}</p>
                        <Link href={car.url}>
                          <button className={styles.saibaMaisButton}>
                            {car.buttonText}
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}

                <button
                  className={`${styles.carouselArrow} ${styles.right}`}
                  onClick={nextCar}
                  aria-label="Próximo veículo"
                >
                  <svg viewBox="0 0 24 24">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                  </svg>
                </button>
              </div>
            </div>

            <div style={{ marginTop: "100px" }} id="plans-section">
              <h2>Planos & Preços</h2>
              <div className={styles.planCardsContainer}>
                {planData.map((plan) => (
                  <div key={plan.title} className={styles.planCard}>
                    <div className={styles.planCardHeader}>
                      <img
                        src={plan.headerSvg}
                        alt={`${plan.title} ícone`}
                        className={styles.planHeaderSvg}
                      />
                      <span className={styles.headerSeparator}> | </span>
                      <div className={styles.planTitleTwoLines}>
                        <h4>{plan.titleLine1}</h4>
                        <h4>{plan.titleLine2}</h4>
                      </div>
                    </div>

                    <div className={styles.planCardContent}>
                      {plan.isFree && (
                        <div className={styles.planPriceFree}>
                          <p className={styles.planStatus}>{plan.status}</p>
                          <p className={styles.planDuration}>{plan.duration}</p>
                        </div>
                      )}

                      <ul className={styles.planFeaturesList}>
                        {plan.features.map((feature) => (
                          <li key={feature} className={styles.planFeatureItem}>
                            <span className={styles.checkIcon}>✔</span>{" "}
                            {feature}
                          </li>
                        ))}
                      </ul>

                      <Link href={plan.url}>
                        <button className={styles.saibaMaisButton}>
                          {plan.buttonText}
                        </button>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
              <p className={styles.planDisclaimer}>
                *Após o período gratuito, consulte condições e valores do plano
                escolhido. Para ter a gratuidade de 1 ano, é necessário adquirir
                um modelo Conectado, realizar a ativação na concessionária,
                baixar o app Toyota e informar um cartão de crédito válido.
              </p>
            </div>
          </div>
        )}

        {activeTab === "app" && (
          <div className={styles.appFeaturesContainer}>
            <h2>Conheça as funcionalidades</h2>
            {appFeaturesData.map((feature) => (
              <div
                key={feature.title}
                className={`${styles.appFeature} ${
                  feature.imagePosition === "right" ? styles.reversed : ""
                }`}
              >
                <div className={styles.appFeatureImage}>
                  <Image
                    src={feature.imageUrl}
                    alt={feature.title}
                    width={600}
                    height={400}
                    className={styles.featureImage}
                    sizes="(max-width: 768px) 100vw, 50vw"
                  />
                </div>
                <div className={styles.appFeatureContent}>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={styles.parallaxSection}>
        <div className={styles.appDownloadContainer}>
          <div className={styles.qrCodeContainer}>
            <Image
              src={`${BLOB}/QRCode.jpg`}
              alt="QR Code"
              width={120}
              height={120}
            />
          </div>
          <div className={styles.appStoresContainer}>
            <Image
              src={`${BLOB}/Google Play.svg`}
              alt="Disponível no Google Play"
              width={150}
              height={50}
            />
            <Image
              src={`${BLOB}/App Store.svg`}
              alt="Baixar na App Store"
              width={150}
              height={50}
            />
          </div>
          <div className={styles.appDownloadText}>
            <h2>Acesse pelo Toyota App</h2>
            <p>
              Os Serviços Conectados podem ser acessados através do Toyota App.
              Baixe o app, adicione seu veículo conectado e explore uma nova
              maneira de interagir com seu Toyota.
            </p>
            <button
              className={styles.downloadAppButton}
              onClick={handleAppDownload}
            >
              Baixe aqui
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServicosConectadosPage;
